import { Skeleton } from '@ui/Skeleton';
import { FeedAsideSkeleton } from '@components/FeedAside';
import { ProductsFeedSleketon } from '@components/ProductsFeedSleketon';

import s from './Catalog.sss';

export const CatalogSkeleton = () => (
  <div className={s.root}>
    <div className={s.side}>
      <FeedAsideSkeleton />
    </div>

    <div className={s.content}>
      <Skeleton
        className={s.title}
        width="400px"
        height="32px"
      />

      <div className={s.controls}>
        <div className={s.sort}>
          <Skeleton
            width="150px"
            height="40px"
            align="left"
          />
        </div>
        <div className={s.filtersButton}>
          <Skeleton
            width="150px"
            height="40px"
            align="right"
          />
        </div>
      </div>

      <ProductsFeedSleketon count={12} />
    </div>
  </div>
);
